import { gql } from '@apollo/client';

export const apiKeyQuery = gql`
    query ApiKey ($id: ID!){
        apiKey (id: $id) {
            _id
            is_public
        }
    }
`;